export const parseTime = (time: string) => {
  if (!time) {
    return time;
  }
  if (time.length > 5) {
    return time.slice(0, time.lastIndexOf(":"));
  }
  return time;
};
